type NavigationConfirmationHandler = () => boolean | Promise<boolean>

let activeNavigationConfirmationHandler: NavigationConfirmationHandler | null = null

export const registerNavigationConfirmation = (handler: NavigationConfirmationHandler) => {
    activeNavigationConfirmationHandler = handler

    return () => {
        if (activeNavigationConfirmationHandler === handler) {
            activeNavigationConfirmationHandler = null
        }
    }
}

export const confirmNavigation = async () => {
    if (!activeNavigationConfirmationHandler) {
        return true
    }

    return activeNavigationConfirmationHandler()
}
